import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/modules/iframe/iframe';
import { environment } from './environments/environment';
import { facilityModule } from './environments/main-module';

window.__KEYCLOAK_INITIAL_HASH__ = window.location.hash;

// eslint-disable-next-line
(window as any).APP_CONFIG = {
    project: environment?.project,
    blackListedHosts: environment?.blackListedHosts,
};

if (environment.production) {
    enableProdMode();

    if (window.console) {
        window.console.log = () => {};
        window.console.warn = () => {};
        window.console.time = () => {};
        window.console.timeEnd = () => {};
    }
}

if (environment.standalone) {
    bootstrapApplication(facilityModule, appConfig);
} else {
    platformBrowserDynamic().bootstrapModule(facilityModule);
}
